export default "__VITE_ASSET__CtB5ulW3__"